import Vue from 'vue'
import Vuetify, { VSelect, VExpansionPanelHeader, VDataTableHeader } from 'vuetify/lib'
import theme from './theme'
import i18n from '../locale'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import '@mdi/font/css/materialdesignicons.css'
import 'typeface-dosis/index.css'
import 'typeface-open-sans/index.css'
import StreamLineIcons from './icons/StreamLineIcons'
Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    themes: {
      light: theme
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi',
    //- Streamline icons
    values: StreamLineIcons
  },
  options: {
    minifyTheme(css) {
      return process.env.NODE_ENV === 'production' ? css.replace(/[\r\n|\r|\n]/g, '') : css
    }
  }
})

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

const LIST_ICON = '$sl-arrow-down';

VSelect.options.props.appendIcon.default = LIST_ICON;
VExpansionPanelHeader.options.props.expandIcon.default = LIST_ICON;
VDataTableHeader.options.props.sortIcon.default = LIST_ICON;

export default vuetify
